jQuery(document).ready(function ($) {

    if ($(window).width() > 992) {
        $('.main-nav__item--has-child, .sub-menu').hover(
            function () {
                $('body').addClass('menu-hover');

                if ($('.home').length > 0) {
                    $(".header").addClass('header--dark');
                }
            },
            function () {
                $('body').removeClass('menu-hover');

                if ($('.home').length > 0) {
                    $(".header").removeClass('header--dark');
                }
            }
        );
    }

    if ($(window).width() < 992) {
        $(document).on('click', '.toggle-nav', function () {
            $('body').toggleClass('no-scroll');
            $('.sub-menu').removeClass('show');
            $('.nav--main').toggleClass('show');
            if ($('.home').length) {
                $(".header").toggleClass('header--dark');
            }
            $('.lang-switch__dropdown').removeClass('show');
        });

        $(document).on('click', '.mobile-sub-toggle', function () {
            $(this)
                .toggleClass('active')
                .next().toggleClass('show');
        });

        $(document).on('click', '.sub-menu__close', function () {
            $('.sub-menu').removeClass('show');
        });

        $(document).on('click', '.ham4', function () {
            $(this).toggleClass('active');
        });

        $('.nav--top').appendTo('.nav--main');
        $('#header-contact').appendTo('.nav--main');
        $('.lang-switch').prependTo('.header__main .wrapper__right');

        $('.lang-switch__label').on('click', function () {
            $('.lang-switch__dropdown').toggleClass('show');
        });

        $('.lang-switch__close').on('click', function () {
            $('.lang-switch__dropdown').removeClass('show');
        });
    }

    let header = $('.header');
    let navHeight = header.outerHeight();

    $(document).on('click', 'a[href^="#"]:not(.close-search-form)', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - navHeight - 140
        }, 500);
    });

    /*-- Scroll Up/Down add class --*/
    let lastScrollTop = 0;
    $(window).scroll(function () {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            header.addClass('header--scroll-down');
            header.removeClass('header--scroll-up');
            $('.page-navigation').removeClass('page-navigation--scroll-up');
            if ($(window).width() > 992) {
                $('.price-wrapper').removeClass('price-wrapper--scroll-up');
                $('.sticky-content').removeClass('sticky-content--scroll-up');
            }
        } else {
            header.addClass('header--scroll-up');
            header.removeClass('header--scroll-down');
            $('.page-navigation').addClass('page-navigation--scroll-up');
            if ($(window).width() > 992) {
                $('.price-wrapper').addClass('price-wrapper--scroll-up');
                $('.sticky-content').addClass('sticky-content--scroll-up');
            }
        }

        lastScrollTop = st;
        if (st >= 300) {
            header.addClass('header--fixed');
            $('.sticky-bar').addClass('sticky-bar--visible');
        } else {
            header.removeClass('header--fixed');
            $('.sticky-bar').removeClass('sticky-bar--visible');
        }
    });



    $('.file-upload input').change(function () {
        $('.file-upload .gfield_label').text(this.files[0].name);
    });

    $(document).on('click', '.toggle-search', function () {
        $('.search-overlay').addClass('open');
        $('#search-site').focus();
    });

    $(document).on('click', '.close-search-form', function () {
        $('.search-overlay').removeClass('open');
    });

    // Filter toggle functions
    if ($(window).width() < 992) {
        $(document).on('click', '.toggle-filter', function () {
            $('.filter').addClass('open');
        });

        $(document).on('click', '.filter', function (e) {
            $('.toggle-filter .icon .ham4').removeClass('active');
            $('.filter').removeClass('open');
        });

        // Prevent events from getting pass .popup
        $(document).on('click', '.filter-wrapper', function (e) {
            e.stopPropagation();
        });

        $(document).on('click', '.filter-close', function () {
            $('.filter').removeClass('open');
            $('.toggle-filter .icon .ham4').toggleClass('active');
        });
    }
});
